<template>
  <v-dialog v-model="show" max-width="700px"
            @click:outside="$store.commit('close_edit_attachment_admin_dialog')">
    <v-card>
      <v-toolbar flat color="primary" dark class="justify-center">
        <v-toolbar-title>
          ویرایش
          {{ get_attachment_type_text(dialog_value.attachment.type) }}
        </v-toolbar-title>
      </v-toolbar>


      <validation-observer v-slot="{ valid }" ref="observer">
        <v-card-text>

          <!--selecting related cast-->
          <!-- uploading document if type of attachment is selected -->
          <Uploader v-if="show"
                    is_required
                    :document="dialog_value.document"
                    :url="$store.state.base_url+'/submissions/document/upload/'"
                    :text="'انتخاب ' + document_type.title"
                    :icon="document_type.icon"
                    :type='3'
                    :accept="document_type.accept"
                    @upload_succeed="set_document"
                    @is_uploading="uploading"
                    @re_upload="re_upload"
          />


        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="$store.commit('close_add_attachment_admin_dialog')">
            لغو
          </v-btn>
          <v-btn color="primary" :disabled="!valid || disabled" @click="edit">
            ویرایش
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>

</template>

<script>
import Uploader from "@/components/submit/steps/Uploader";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {mapState} from "vuex";
import Statics from "@/components/common/Statics";

export default {
  name: "EditAttachmentsAdminDialog",
  components: {
    Uploader,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      show: state => state.Admin.settings.edit_attachment_dialog.show,
      dialog_value: state => state.Admin.settings.edit_attachment_dialog,
    }),
  },
  data() {
    return {
      cast_phone: "",
      document_type: {
        title: 'فایل',
        icon: 'mdi-file',
        type: '1',
        accept: 'image/*',
      },
      disabled: false,
      attachment_types: Statics.attachments

    }
  },
  methods: {
    get_attachment_type_text(obj){
      let text = ""
      this.attachment_types.forEach((element) => {
        if (element.type == obj) {
          text = element.title
        }
      })
      return text
    },
    edit() {
      this.$store.dispatch("edit_attachment_admin")
    },
    set_document(document) {
      this.disabled = false;
      this.$store.commit("set_edit_attachment_file_admin", {document: document});
    },
    uploading(is_uploading) {
      this.$store.commit("file_uploading", is_uploading);
    },
    re_upload() {
      this.disabled = true;
      this.set_document_type()
      // this.$store.commit("remove_extra_file", {document: null, type: this.dialog_value.type.type});
    },
    set_document_type() {
      this.document_type = Statics.extra_file_sections[this.dialog_value.attachment.type - 1]
    },


  },
  watch: {
    show: function () {
      console.log(this.dialog_value)
      this.$refs.observer.reset();
      this.disabled = false
      this.set_document_type()
    },
  }
}

</script>

<style scoped>

</style>